<template>
    <div class="bg-light-gray">
        <div class="container">
            <h1 class="pt-5 mb-0 text-center">{{msg}}</h1>

            <div class="text-center py-5">
                <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
                    Launch demo modal
                </button>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam consectetur culpa doloribus et libero, nobis recusandae! Ab, accusantium ad alias aspernatur assumenda cumque deserunt earum expedita fugit illum, ipsa itaque molestiae quaerat qui quis recusandae reiciendis rerum sit tempora tenetur. Ab alias aliquid, debitis dolores doloribus dolorum ducimus ea enim esse expedita facilis fugit harum, natus nemo nobis officia quidem quod sed sint tempore ullam ut veniam voluptatum. Accusamus adipisci aperiam at atque commodi cum cumque dicta dolor earum eligendi enim ipsum iure, iusto mollitia non nostrum officiis omnis pariatur perferendis placeat provident quasi qui quibusdam quod temporibus voluptates voluptatibus.</p>
                        </div>
                        <div class="modal-footer">
                            <div class="btn-left">
                                <a href="#" class="btn btn-link">More info</a>
                            </div>
                            <div class="btn-right">
                                <button class="btn btn-link" data-dismiss="modal">Decline</button>
                                <button class="btn btn-link" data-dismiss="modal">Accept</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--Ends Modal-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "Modal",
        data() {
            return {
                msg: 'Modal'
            }
        }
    }
</script>

<style lang="scss">
    @import "../assets/scss/variables";

    .modal {
        .modal-title {
            color: $alert-blue;
        }
        .modal-content {
            box-shadow: 0 0 24px 0 rgba(0,0,0,0.12),
            0 12px 24px 0 rgba(0,0,0,0.15);
            border: 0;
        }

        .modal-header {
            padding-bottom: 0;
            border-bottom: 0;
        }

        .modal-footer {
            justify-content: space-between;
            padding-top: 0;
            border-top: 0;
        }

        .close {
            color: $alert-blue;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Modal.vue